import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import {
  Box,
  Button,
  Modal,
  Backdrop,
  Fade,
  TextField,
  Typography,
  useMediaQuery,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import Select from "react-select";
import { InputAdornment, IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const apiUrl = process.env.REACT_APP_API_REST_URL;

const initializeOtpInputRefs = () => {
  return Array.from({ length: 6 }, () => useRef(null));
};

const InsuranceReg = (props) => {
  // useEffect(() => {
  //   document.title = "Optimus InvesTek";
  // });
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const [username, setUsername] = useState("");
  const [userarray, setUserarray] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [verificationMessage, setVerificationMessage] = useState("");
  const [isPolicyChecked, setIsPolicyChecked] = useState(false);

  const [userId, setUserId] = useState("");
  const otpInputRefs = initializeOtpInputRefs();

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(
      (prevShowConfirmPassword) => !prevShowConfirmPassword
    );
  };

  const handleCheckboxChange = (event) => {
    setIsPolicyChecked(event.target.checked);
  };

  const handleresendOtp = async () => {
    const phoneAsNumber = parseInt(phone, 10);
    try {
      const res = await axios.post(
        `${apiUrl}/CCE/api/v1/commonEngine/reSendOtp`,
        {
          candidate_id: userId,
          candidate_type: "user",
          phone: phoneAsNumber,
        }
      );
      if (res) {
        toast.success(
          "Otp resent to your registered phone number successfully!"
        );
      }
      console.log("reswa of resendwa", res);
    } catch (error) {
      console.error("Error:", error.message);
      toast.error("Failed to resend otp. Please try again.");
    }
  };

  const handlepointofcontactChange = (selectedOption) => {
    setUsername(selectedOption);
  };
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);

  // const handleVerifyOTP = () => {
  //   setOtpModalOpen(true);
  // };

  const handleCloseModal = () => {
    setOtpModalOpen(false);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    // setValue,
    watch,
  } = useForm({ mode: "onTouched" });
  const phone = watch("phone", ""); // Provide the default value as the second argument

  const handleChange = (index, value) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    const otpString = otp.join("");
    console.log("otp", otpString);
    console.log("phone", phone);
    if (index < 5 && value !== "") {
      otpInputRefs[index + 1].current.focus();
    }
  };

  // const data = {
  //   "phone":7456859542,
  //   "otp":2711,
  // }

  const handleOtpVerification = async () => {
    const otpAsNumber = parseInt(otp.join(""), 10);
    const phoneAsNumber = parseInt(phone, 10);

    try {
      const res = await axios.post(
        `${apiUrl}/CCE/api/v1/commonEngine/mobile_verify`,
        {
          phone: phoneAsNumber, // Access phone value from data object
          otp: otpAsNumber,
        }
      );
      console.log("response", res);
      if (res.data.response.message === "Otp Verified") {
        setVerificationMessage(
          "Great news! Your phone number has been successfully verified, and your account is now fully activated.Thank you for completing the phone verification process."
        );
        setOtp(["", "", "", "", "", ""]);
        setTimeout(() => {
          navigate("/agreement", { state: { userId } });
        }, 2000);
        // toast.success("Otp verified successfully!");
      } else if (res.data.response.message === "Incorrect otp") {
        // toast.error("Otp not verified successfully!");
        setVerificationMessage(
          "We regret to inform you that the One-Time Password (OTP) entered for phone verification is not valid. Please ensure that you have entered the correct OTP provided in the SMS sent on your phone."
        );
        setOtp(["", "", "", "", "", ""]);
        // toast.error("Otp not verified successfully!");
      }
    } catch (error) {
      console.error("Error:", error.message);
      toast.error("Network error. Please try again.");
    }

    // setVerificationMessage(" ");

    // Add your OTP verification logic here
    // For simplicity, let's just close the modal for now
    // handleCloseModal();
  };
  const password = watch("password", "");

  const navigate = useNavigate();

  const onSubmit = async (data) => {
    console.log(data, "dta1");
    props.setdata({ ...data, isFromIns: true });
    try {
      const response = await axios.post(
        `${apiUrl}/CCE/api/v1/userEngine/signup`,
        {
          ...data,
          // consent : isPolicyChecked,
          pointOfContact: username?.value,
          countryCode: 91,
          roleId: 4,
        }
      );
      // await axios.get(`${url}commonEngine/professions`);

      console.log("Response: signup", response);
      if (
        response &&
        response.data.status === false &&
        response.data.statusMessage === "Validation Error"
      ) {
        // Check if the response is related to Email/Phone existence
        const errorMessage = response.data.response;
        if (errorMessage === "Email / Phone already exist") {
          toast.error("Email / Phone already exist");
        } else {
          toast.error(errorMessage || "Validation Error");
        }
      } else if (response.data.response.userAlreadyExist) {
        toast.error("Email/Phone already exist");
      } else {
        toast.success("Signup successful!");
        // setOtpModalOpen(true); // Open the OTP modal

        // Wait for a short delay to allow the modal to render
        setTimeout(() => {
          const userId = response.data.response.id;
          setUserId(userId); // Access the 'id' property from the response
          navigate("/thankyou", { state: { userId } });

          navigate("/agreement", { state: { userId } });
        }, 500); // You can adjust the delay as needed
      }
    } catch (error) {
      console.error("Error details:", error.response);

      if (error.response && error.response.data) {
        // Checking if the server returned a known error response
        const errorMessage =
          error.response.data.response || "Signup failed. Please try again.";
        toast.error(errorMessage);
      } else {
        // Handle unknown errors (network, server unavailability, etc.)
        toast.error("An unknown error occurred. Please try again.");
      }
    }
  };

  //--------------------Submit area (end)----------------------------

  // const onSubmit = (data) => {
  //   console.log(data);
  // };

  const handleSignup = () => {
    navigate("/insurance-signin");
  };

  //   const handleCancel = () => {
  //     navigate("/");
  //   };

  const handleCheck = async () => {
    const res = await axios.post(`${apiUrl}/CCE/api/v1/userEngine/users`, {
      roleId: 2,
    });
    const result = res.data.response;
    console.log("asdfdfglkjdfgjkjhkjl", result);
    const username = result.map((profession) => ({
      value: profession.id,
      label: `${profession.firstname} ${profession.lastname}`,
    }));
    setUserarray(username);
  };

  useEffect(() => {
    handleCheck();
  }, []);

  return (
    <>
      {isSmallScreen ? (
        <span>
          <Box>
            <Box sx={styles.formboxresponsive}>
              {/* <Box
                onClick={handleCancel}
                sx={{
                  textAlign: "right",
                  cursor: "pointer",
                  color: "#666666",
                }}
              >
                <CloseIcon />
              </Box> */}
              <h2 style={{ marginTop: "0px" }}>
                Protect Tomorrow - Sign Up Today!
              </h2>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                  {/* <label>First name:</label> */}
                  <TextField
                    size="small"
                    sx={styles.textfieldres}
                    id="outlined-basic"
                    label="First name"
                    variant="outlined"
                    {...register("firstname", {
                      required: "First Name is required",
                      errorMessage: "name is allowed in only letters",
                      pattern: {
                        value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                        message: "Only alphabets are allowed",
                      },
                    })}
                  />
                  {errors.firstname && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.firstname.message}
                    </div>
                  )}
                </div>
                <div style={{ marginTop: "16px" }}>
                  {/* <label>Last name:</label> */}
                  <TextField
                    size="small"
                    sx={styles.textfieldres}
                    id="outlined-basic"
                    label="Last name"
                    variant="outlined"
                    {...register("lastname", {
                      required: "Last Name is required",
                      errorMessage: "Last name is allowed in only letters",
                      pattern: {
                        value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                        message: "Only alphabets are allowed",
                      },
                    })}
                  />
                  {errors.lastname && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.lastname.message}
                    </div>
                  )}
                </div>
                <div style={{ marginTop: "16px" }}>
                  {/* <label>Email address:</label> */}
                  <TextField
                    size="small"
                    sx={styles.textfieldres}
                    id="outlined-basic"
                    label="Email address"
                    variant="outlined"
                    {...register("email", {
                      required: "Email address is required",
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "Invalid Email Address",
                      },
                    })}
                  />
                  {errors.email && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.email.message}
                    </div>
                  )}
                </div>
                <div style={{ margin: "16px 0px 14px 0px" }}>
                  {/* <label>Phone number:</label> */}
                  <TextField
                    size="small"
                    sx={styles.textfieldres}
                    id="outlined-basic"
                    label="Phone number"
                    variant="outlined"
                    {...register("phone", {
                      required: "Phone number is required",
                      pattern: {
                        value: /^\d{10}$/,
                        message: "Invalid Phone Number (10 digits)",
                      },
                      // onChange: (e) => formatPhoneNumber(e.target.value),
                    })}
                  />
                  {errors.phone && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.phone.message}
                    </div>
                  )}
                </div>
                <div style={{ marginTop: "16px" }}>
                  <TextField
                    size="small"
                    sx={styles.textfieldres}
                    id="outlined-password"
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    variant="outlined"
                    {...register("password", {
                      required: "Password is required",
                      minLength: {
                        value: 6,
                        message: "Password must be at least 6 characters long",
                      },
                    })}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleTogglePasswordVisibility}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {errors.password && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.password.message}
                    </div>
                  )}
                </div>
                {/* Confirm Password field */}
                {/* ------------------------------------------------------------------------ */}

                <div style={{ marginTop: "16px" }}>
                  <TextField
                    size="small"
                    sx={styles.textfieldres}
                    id="outlined-confirm-password"
                    label="Confirm Password"
                    type={showConfirmPassword ? "text" : "password"}
                    variant="outlined"
                    {...register("confirmPassword", {
                      required: "Confirm Password is required",
                      validate: (value) =>
                        value === password || "Passwords do not match",
                    })}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle confirm password visibility"
                            onClick={handleToggleConfirmPasswordVisibility}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {errors.confirmPassword && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.confirmPassword.message}
                    </div>
                  )}
                </div>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{ marginTop: "12px" }}
                      checked={isPolicyChecked}
                      onChange={handleCheckboxChange}
                      name="privacyPolicy"
                    />
                  }
                  label={
                    <Typography variant="body2" sx={{ marginTop: "12px" }}>
                      I agree to InvesTek's{" "}
                      <a
                        href="https://www.investek.in/termsandconditions"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "blue" }}
                      >
                        Terms of Service
                      </a>
                      {" & "}
                      <a
                        href="https://www.investek.in/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "blue" }}
                      >
                        Privacy Policy
                      </a>
                    </Typography>
                  }
                />
                {/* <Box sx={{ marginTop: "0px" }}>
            <Box sx={{ Width: 150 }}>
              <FormControl sx={{ textAlign: "left" }} fullWidth>
                <div
                  style={{
                    margin: "8px 0px 8px 0px",

                    fontSize: "16px",
                  }}
                ></div>
                <Select
                  sx={{ border: "1 px solid green" }}
                  labelId="profession-label"
                  id="profession"
                  value={username}
                  onChange={handlepointofcontactChange}
                  options={userarray}
                  isSearchable
                  placeholder=" Point of Contact in InvesTek?"
                />
              </FormControl>
            </Box>
          </Box> */}
                {/* --------------------------------------------------------------------- */}
                <Box sx={{ marginBottom: "5px" }}>
                  <Button
                    sx={styles.btnres}
                    type="submit"
                    variant="contained"
                    disabled={!isPolicyChecked}
                  >
                    Register Now
                  </Button>
                </Box>
              </form>

              <Box sx={{ marginTop: "20px" }}>
                <Typography>
                  Already have an account?
                  <span
                    style={{ color: "#002c51", cursor: "pointer" }}
                    onClick={handleSignup}
                  >
                    <b> Sign in </b>
                  </span>
                </Typography>
              </Box>
              <Box sx={{ marginTop: "10px" }}>
                {/* <div style={{color:"blue",fontSize:"16px"}} onClick={handleVerifyOTP}>Verify Otp</div> */}

                <Modal
                  open={otpModalOpen}
                  onClose={handleCloseModal}
                  closeAfterTransition
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                    timeout: 500,
                  }}
                >
                  <Fade in={otpModalOpen}>
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        padding: "15px",
                        background: "#FFFFFF",
                        borderRadius: "8px",
                        textAlign: "center",
                        height: "400px",
                        width: "300px",
                      }}
                    >
                      <h2>Mobile Verification</h2>
                      {otp.map((digit, index) => (
                        <TextField
                          key={index}
                          type="text"
                          variant="outlined"
                          size="small"
                          inputProps={{ maxLength: 1 }}
                          value={digit}
                          onChange={(e) => handleChange(index, e.target.value)}
                          style={{ width: "2.5em", marginRight: "0.5em" }}
                          inputRef={otpInputRefs[index]} // Associate ref with the OTP input
                        />
                      ))}
                      <Typography sx={{ marginTop: "4px" }}>
                        Please enter the OTP you received.
                      </Typography>
                      <Button
                        sx={styles.verifybtn}
                        type="button"
                        variant="contained"
                        onClick={handleOtpVerification}
                      >
                        Verify OTP
                      </Button>

                      {verificationMessage && (
                        <div
                          style={{
                            marginTop: "10px",
                            color: verificationMessage.includes("successfully")
                              ? "green"
                              : "red",
                          }}
                        >
                          {verificationMessage}
                        </div>
                      )}
                      <div
                        onClick={handleresendOtp}
                        style={{
                          color: "blue", // Set the text color
                          textDecoration: "underline", // Add an underline to mimic a link
                          cursor: "pointer",
                          marginTop: "5px", // Change the cursor to a hand pointer on hover
                        }}
                      >
                        Resend OTP
                      </div>
                    </Box>
                  </Fade>
                </Modal>
              </Box>
            </Box>
          </Box>
        </span>
      ) : (
        <span>
          <Box>
            <Box sx={styles.formbox}>
              {/* <Box
                onClick={handleCancel}
                sx={{
                  textAlign: "right",
                  cursor: "pointer",
                  color: "#666666",
                }}
              >
                <CloseIcon />
              </Box> */}
              <h2 style={{ marginTop: "0px" }}>
                Protect Tomorrow - Sign Up Today!
              </h2>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                  {/* <label>First name:</label> */}
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    id="outlined-basic"
                    label="First name"
                    variant="outlined"
                    {...register("firstname", {
                      required: "First Name is required",
                      errorMessage: "name is allowed in only letters",
                      pattern: {
                        value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                        message: "Only alphabets are allowed",
                      },
                    })}
                  />
                  {errors.firstname && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.firstname.message}
                    </div>
                  )}
                </div>
                <div style={{ marginTop: "16px" }}>
                  {/* <label>Last name:</label> */}
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    id="outlined-basic"
                    label="Last name"
                    variant="outlined"
                    {...register("lastname", {
                      required: "Last Name is required",
                      errorMessage: "Last name is allowed in only letters",
                      pattern: {
                        value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                        message: "Only alphabets are allowed",
                      },
                    })}
                  />
                  {errors.lastname && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.lastname.message}
                    </div>
                  )}
                </div>
                <div style={{ marginTop: "16px" }}>
                  {/* <label>Email address:</label> */}
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    id="outlined-basic"
                    label="Email address"
                    variant="outlined"
                    {...register("email", {
                      required: "Email address is required",
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "Invalid Email Address",
                      },
                    })}
                  />
                  {errors.email && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.email.message}
                    </div>
                  )}
                </div>
                <div style={{ margin: "16px 0px 14px 0px" }}>
                  {/* <label>Phone number:</label> */}
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    id="outlined-basic"
                    label="Phone number"
                    variant="outlined"
                    {...register("phone", {
                      required: "Phone number is required",
                      pattern: {
                        value: /^\d{10}$/,
                        message: "Invalid Phone Number (10 digits)",
                      },
                      // onChange: (e) => formatPhoneNumber(e.target.value),
                    })}
                  />
                  {errors.phone && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.phone.message}
                    </div>
                  )}
                </div>
                <div style={{ marginTop: "16px" }}>
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    id="outlined-password"
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    variant="outlined"
                    {...register("password", {
                      required: "Password is required",
                      minLength: {
                        value: 6,
                        message: "Password must be at least 6 characters long",
                      },
                    })}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleTogglePasswordVisibility}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {errors.password && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.password.message}
                    </div>
                  )}
                </div>
                {/* Confirm Password field */}
                {/* ------------------------------------------------------------------------ */}

                <div style={{ marginTop: "16px" }}>
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    id="outlined-confirm-password"
                    label="Confirm Password"
                    type={showConfirmPassword ? "text" : "password"}
                    variant="outlined"
                    {...register("confirmPassword", {
                      required: "Confirm Password is required",
                      validate: (value) =>
                        value === password || "Passwords do not match",
                    })}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle confirm password visibility"
                            onClick={handleToggleConfirmPasswordVisibility}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {errors.confirmPassword && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.confirmPassword.message}
                    </div>
                  )}
                </div>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{ marginTop: "12px" }}
                      checked={isPolicyChecked}
                      onChange={handleCheckboxChange}
                      name="privacyPolicy"
                    />
                  }
                  label={
                    <Typography variant="body2" sx={{ marginTop: "12px" }}>
                      I agree to InvesTek's{" "}
                      <a
                        href="https://www.investek.in/termsandconditions"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "blue" }}
                      >
                        Terms of Service
                      </a>
                      {" & "}
                      <a
                        href="https://www.investek.in/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "blue" }}
                      >
                        Privacy Policy
                      </a>
                    </Typography>
                  }
                />
                {/* <Box sx={{ marginTop: "0px" }}>
            <Box sx={{ Width: 150 }}>
              <FormControl sx={{ textAlign: "left" }} fullWidth>
                <div
                  style={{
                    margin: "8px 0px 8px 0px",

                    fontSize: "16px",
                  }}
                ></div>
                
                <Select
                  sx={{ border: "1 px solid green" }}
                  labelId="profession-label"
                  id="profession"
                  value={username}
                  onChange={handlepointofcontactChange}
                  options={userarray}
                  isSearchable
                  placeholder=" Point of Contact in InvesTek?"
                />
              </FormControl>
            </Box>
          </Box> */}
                {/* --------------------------------------------------------------------- */}
                <Box sx={{ marginBottom: "5px" }}>
                  <Button
                    sx={styles.btn}
                    type="submit"
                    variant="contained"
                    disabled={!isPolicyChecked}
                  >
                    Register Now
                  </Button>
                </Box>
              </form>

              <Box sx={{ marginTop: "20px" }}>
                <Typography>
                  Already have an account?
                  <span
                    style={{ color: "#002c51", cursor: "pointer" }}
                    onClick={handleSignup}
                  >
                    <b> Sign in </b>
                  </span>
                </Typography>
              </Box>
              <Box sx={{ marginTop: "10px" }}>
                {/* <div style={{color:"blue",fontSize:"16px"}} onClick={handleVerifyOTP}>Verify Otp</div> */}

                <Modal
                  open={otpModalOpen}
                  onClose={handleCloseModal}
                  closeAfterTransition
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                    timeout: 500,
                  }}
                >
                  <Fade in={otpModalOpen}>
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        padding: "15px",
                        background: "#FFFFFF",
                        borderRadius: "8px",
                        textAlign: "center",
                        height: "400px",
                        width: "300px",
                      }}
                    >
                      <h2>Mobile Verification</h2>
                      {otp.map((digit, index) => (
                        <TextField
                          key={index}
                          type="text"
                          variant="outlined"
                          size="small"
                          inputProps={{ maxLength: 1 }}
                          value={digit}
                          onChange={(e) => handleChange(index, e.target.value)}
                          style={{ width: "2.5em", marginRight: "0.5em" }}
                          inputRef={otpInputRefs[index]} // Associate ref with the OTP input
                        />
                      ))}
                      <Typography sx={{ marginTop: "4px" }}>
                        Please enter the OTP you received.
                      </Typography>
                      <Button
                        sx={styles.verifybtn}
                        type="button"
                        variant="contained"
                        onClick={handleOtpVerification}
                      >
                        Verify OTP
                      </Button>

                      {verificationMessage && (
                        <div
                          style={{
                            marginTop: "10px",
                            color: verificationMessage.includes("successfully")
                              ? "green"
                              : "red",
                          }}
                        >
                          {verificationMessage}
                        </div>
                      )}
                      <div
                        onClick={handleresendOtp}
                        style={{
                          color: "blue", // Set the text color
                          textDecoration: "underline", // Add an underline to mimic a link
                          cursor: "pointer",
                          marginTop: "5px", // Change the cursor to a hand pointer on hover
                        }}
                      >
                        Resend OTP
                      </div>
                    </Box>
                  </Fade>
                </Modal>
              </Box>
            </Box>
          </Box>
        </span>
      )}
    </>
  );
};

export default InsuranceReg;

const styles = {
  formbox: {
    position: "absolute",
    top: "51%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "534px",
    width: "420px",
    overflow: "auto",

    scrollbarWidth: "thin",
    scrollbarColor: "#d9d9d9 #fff",
    "&::-webkit-scrollbar": {
      width: "2px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#d9d9d9",
    },
  },

  formboxresponsive: {
    position: "absolute",
    top: "51.4%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "520px",
    width: "320px",
    overflow: "auto",

    scrollbarWidth: "thin",
    scrollbarColor: "#d9d9d9 #fff",
    "&::-webkit-scrollbar": {
      width: "2px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#d9d9d9",
    },
  },

  textfield: {
    width: "400px",
  },
  textfieldres: {
    width: "300px",
  },
  btn: {
    width: "400px",
    height: "40px",
    marginTop: "1em",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  btnres: {
    width: "300px",
    height: "40px",
    marginTop: "1em",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  verifybtn: {
    width: "150px",
    height: "40px",
    marginTop: "1em",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
};
